export class Bid
{
    id:string;
    title:string;
    brief:string;
    description:string;
    expirationDate:string;
    modificationDate:string;
    file:string;
    fileName:string;
    url:string;
}